import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { PostavitevInfoComponent } from '../postavitev-info/postavitev-info.component';

@Component({
  selector: 'lib-app-topbar-bot',
  templateUrl: './app.topbar-bot.component.html',
  styleUrl: './app.topbar-bot.component.scss',
  imports: [RouterLink, PostavitevInfoComponent],
})
export class AppTopBarBotComponent {}
